import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetail from "./component";

const mapStateToProps  = ({
    abExperiment: {
        showDesktopCdpRevamp
    }
}) => ({
    showDesktopCdpRevamp
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDetail);
